/**
 * CareMap overlay header: floating search, zoom stack, and `AdCarousel` (mapHeader placement).
 *
 * Carousel + search use `top: calc(100% + MAP_HEADER_FLOAT_ROW_TOP_PX)` on {@link HeaderWrapper}.
 * **100%** = bottom of the in-flow white header (height varies with filters, ads, breakpoints).
 * So: distance from **top of map pane** to **top of carousel/search** =
 *   `HeaderWrapper` content height + `MAP_HEADER_FLOAT_ROW_TOP_PX` (not a single fixed px).
 */

/** Right reserve for carousel strip: search button (36px) + edge margin (see Header.js). */
export const MAP_HEADER_INLINE_RIGHT_RESERVE_PX = 52;

/**
 * Gap (px) from the **bottom edge of the white header** down to the top of the ad carousel and
 * search icon. Larger = more map tiles visible between header and carousel.
 */
export const MAP_HEADER_FLOAT_ROW_TOP_PX = 24;

/** Map search `IconButton` outer size — used to place zoom under search. */
export const MAP_HEADER_SEARCH_BUTTON_PX = 36;

/** Gap between search bottom and zoom-in top. */
export const MAP_HEADER_SEARCH_TO_ZOOM_GAP_PX = 5;

/** Pixels below header bottom: top of the zoom + / − column (aligned under search). */
export const MAP_HEADER_ZOOM_STACK_TOP_PX =
  MAP_HEADER_FLOAT_ROW_TOP_PX +
  MAP_HEADER_SEARCH_BUTTON_PX +
  MAP_HEADER_SEARCH_TO_ZOOM_GAP_PX;

/** Gap (px) from the **bottom edge of the map pane** up to the bottom of the ad carousel (stacked embed). */
export const MAP_CAROUSEL_MAP_BOTTOM_INSET_PX = 10;
